/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_Manual_CtaInputs */

const en_mk_build_manual_cta = /** @type {(inputs: Mk_Build_Manual_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your computer`)
};

const id_mk_build_manual_cta = /** @type {(inputs: Mk_Build_Manual_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan komputer sendiri`)
};

/**
* | output |
* | --- |
* | "Connect your computer" |
*
* @param {Mk_Build_Manual_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_manual_cta = /** @type {((inputs?: Mk_Build_Manual_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_Manual_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_manual_cta(inputs)
	return en_mk_build_manual_cta(inputs)
});